const loanapplicationRoutes = [

    {

        name: 'loanApplicationHome',
        path: '',
        component: () =>
            import ('./LoanApplications.vue'),
        meta: {
            auth: true,
            title: 'Loan Applications',
            breadcrumb: 'Loan Applications',
            permission: ['view loanapplication']
        },

    },



    {

        name: 'disburseloan',
        path: 'disburse',
        component: () =>
            import ('./DisburseApplications.vue'),
        meta: {
            auth: true,
            title: 'Disburse Applications',
            breadcrumb: 'Disburse Applications',
            permission: ['disburse loanapplication']
        },

    },

    

     {
        path: 'show/:id',
        name: 'showLoanApplication',
        component: () =>
            import ('../Loan/ShowLoan.vue'),
        meta: {
            auth: true,
            title: 'Showing Loan Application',
            breadcrumb: 'Loan Facilty',
            permission: ['view loanapplication'],
            section: 'loanapplication'
        }
    },

     {
        path: ':id/edit',
        name: 'editLoan',
        component: () =>
            import ('./EditLoan.vue'),
        meta: {
            auth: true,
            title: 'Edit Loan Facility',
            breadcrumb: 'Loan Application',
            permission: ['update loanapplication'],
        }
    },




];

export default loanapplicationRoutes;
